<div class="flex items-center gap-x-2">
  <div
    [ngClass]="bgLogo"
    class="flex items-center justify-center w-9 h-9 border-[1px] border-primary rounded-full">
    <i
      [ngClass]="colorLogo"
      class="pi pi-home text-xl"></i>
  </div>
  <div class="flex flex-col md:flex-row items-center h-9">
    <span class="font-app-bold text-darkest text-sm"> {{ data!.address }}{{ "quotation.comma" | translate }} </span>
    <span class="font-app-bold text-darkest text-sm md:ml-1">{{ data.postalCode }} {{ data.city }}</span>
  </div>
</div>

